import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const VerificationCompletePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [id, setId] = useState('');
  const [studentData, setStudentData] = useState({
    name: '',
    idCard: '',
    stuNum: '',
    phone: '',
    rstMsg: '' // 新增rstMsg字段
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [redirectTimer, setRedirectTimer] = useState(null);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlId = searchParams.get('id');
    const sessionId = sessionStorage.getItem('__secure_id');
    
    const finalId = urlId || sessionId;
    
    if (!finalId) {
      handleVerificationError();
      return;
    }

    setId(finalId);
    fetchStudentData(finalId);

    if (window.history.replaceState) {
      const cleanURL = window.location.pathname;
      window.history.replaceState(null, '', cleanURL);
    }
    sessionStorage.removeItem('__secure_id');
  }, [location, navigate]);

  const handleVerificationError = () => {
    setIsError(true);
    
    let seconds = 3;
    setCountdown(seconds);
    
    const timer = setInterval(() => {
      seconds -= 1;
      setCountdown(seconds);
      
      if (seconds <= 0) {
        clearInterval(timer);
        navigate(-1);
      }
    }, 1000);
    
    setRedirectTimer(timer);
  };

  useEffect(() => {
    return () => {
      if (redirectTimer) {
        clearInterval(redirectTimer);
      }
    };
  }, [redirectTimer]);

  const fetchStudentData = async (id) => {
    try {
      const response = await fetch('api/auth-logs/get', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id })
      });
      
      const result = await response.json();
      
      if (result.code === 0 && result.data) {
        setStudentData({
          name: result.data.name || '',
          idCard: result.data.idCard || '',
          stuNum: result.data.stuNum || '',
          phone: result.data.phone || '',
          rstMsg: result.data.rstMsg || '您的手机号码已绑定成功' // 设置rstMsg，如果不存在则使用默认值
        });
      } else {
        handleVerificationError();
      }
    } catch (error) {
      handleVerificationError();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card">
        {isError ? (
          <div className="error-section" style={{ 
            padding: '40px', 
            textAlign: 'center',
            background: '#ffebee',
            borderRadius: '8px',
            margin: '20px'
          }}>
            <i className="fas fa-exclamation-triangle" style={{ 
              fontSize: '3rem', 
              color: '#ff4444',
              marginBottom: '20px'
            }}></i>
            <h2 style={{ color: '#ff4444', marginBottom: '10px' }}>验证失败</h2>
            <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '20px' }}>
              {countdown}秒后自动返回，或
              <button 
                onClick={() => {
                  if (redirectTimer) clearInterval(redirectTimer);
                  navigate(-1);
                }}
                style={{ 
                  color: '#2196F3',
                  cursor: 'pointer',
                  padding: '0 4px',
                  border: 'none',
                  background: 'none',
                  textDecoration: 'underline',
                  marginLeft: '5px'
                }}
              >立即返回</button>
            </p>
          </div>
        ) : (
          <>
            <div className="card-header" style={{ 
              background: 'linear-gradient(135deg, #db1f26, #db1f26)', 
              padding: '40px 30px', 
              textAlign: 'center', 
              color: 'white',
              borderRadius: '8px 8px 0 0'
            }}>
              <h1 style={{ fontSize: '2rem', marginBottom: '20px' ,display: 'flex',
  flexDirection: 'column',alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center'}}>
                <img src="/logo.png" alt="泉州师范学院" className="header-logo" />
                <i className="fas fa-check-circle"></i> 验证完成
              </h1>
              {/* 修改此处：显示rstMsg而不是固定文本 */}
              <p style={{ fontSize: '1.1rem' }}>{studentData.rstMsg}</p>
            </div>

            <div className="info-section" style={{ 
              padding: '30px',
              border: '1px solid #eee',
              borderRadius: '0 0 8px 8px'
            }}>
              {isLoading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <i className="fas fa-spinner fa-spin" style={{ 
                    fontSize: '2rem', 
                    marginBottom: '20px',
                    color: '#27ae60'
                  }}></i>
                  <p>正在加载数据...</p>
                </div>
              ) : (
                <>
                  {[
                    { label: '姓名', value: studentData.name },
                    { label: '学号/工号', value: studentData.stuNum },
                    { label: '电话号码', value: studentData.phone }
                  ].map((item, index) => (
                    <div className="info-item" key={index} style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '15px 0',
                      borderBottom: index !== 2 ? '1px solid #eee' : 'none'
                    }}>
                      <div className="info-content" style={{ flex: 1 }}>
                        <div className="info-label" style={{
                          fontSize: '0.9rem',
                          color: '#666',
                          marginBottom: '5px'
                        }}>{item.label}</div>
                        <div className="info-value" style={{
                          fontSize: '1.1rem',
                          fontWeight: 500
                        }}>
                          {item.value || '未获取'}
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
            
            {!isError && !isLoading && (
              <div style={{ 
                padding: '20px', 
                textAlign: 'center',
                borderTop: '1px solid #eee'
              }}>
                <button 
                  onClick={() => (window.location.href='https://id.qztc.edu.cn')}
                  style={{
                    padding: '12px 24px',
                    backgroundColor: '#db1f26',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    fontWeight: '500',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#b71c22'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#db1f26'}
                >
                  前往首页
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default VerificationCompletePage;